import React from 'react';

const MzCreditsIcon = () => (
  <svg
    aria-hidden="true"
    style={{ color: '#0f0f0f', width: '16px', height: '16px' }}
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <circle
      cx="12"
      cy="12"
      r="6.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      opacity="0.55"
    />
    <text
      x="12"
      y="14.2"
      fill="currentColor"
      fontFamily="Arial, sans-serif"
      fontSize="5.8"
      fontWeight="800"
      textAnchor="middle"
    >
      MZ
    </text>
  </svg>
);

export default MzCreditsIcon;
